import { render, staticRenderFns } from "./ClientInformations.vue?vue&type=template&id=b6eabb50&scoped=true&"
import script from "./ClientInformations.vue?vue&type=script&lang=js&"
export * from "./ClientInformations.vue?vue&type=script&lang=js&"
import style0 from "./ClientInformations.vue?vue&type=style&index=0&id=b6eabb50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6eabb50",
  null
  
)

export default component.exports